<style>
</style>

<template>
<v-dialog v-model="dialog" persistent max-width="300px">
  <template v-slot:activator="{ on }">
    <a color="primary" text v-on="on">{{ $t('Zadejte slevový kód') }}</a>
  </template>
  <v-card>
    <v-toolbar fixed flat height="60px">
      <v-spacer></v-spacer>
      <v-toolbar-title class="justify-center headline primary--text">
        {{ $t('Slevový kód') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn id="revert-button" icon @click.native="dialog = false" v-on="on">
            <v-icon>close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Zrušení změn') }}</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="background: secondary">
      <v-container fluid grid-list-sm>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-text-field solo flat v-model="couponId" :rules="reductionRules" :hint="$t('Slevový kód')" persistent-hint></v-text-field>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn color="primary" @click="addCode()">{{ $t('Použít') }}</v-btn>
          </v-col>
          <v-col class="text-center">
            <v-alert type="error" :value="$error.hasStatus">{{ $t($error.errorText) }}</v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-data-table v-if="this.basket.coupons && this.basket.coupons.length > 0" class="elevation-1" :headers="headers" :items="this.basket.coupons" hide-default-footer hide-headers item-key="couponId">
      <template v-slot:item.options="{ item }">
        <v-btn class="mx-0" icon @click="removeCode(item)">
          <v-icon color="red">delete</v-icon>
        </v-btn>
      </template>
      <template v-slot:body.append>
        <tr>
          <td><strong>{{ $t('Použito') }}</strong></td>
          <td class="text-right"><strong>{{ totalDiscount | currency }}</strong></td>
        </tr>
        <tr>
          <td><strong>{{ $t('Celkem') }}</strong></td>
          <td class="text-right"><strong>{{ totalPrice - totalDiscount | currency }}</strong></td>
        </tr>
      </template>

      <!-- <template slot="items" slot-scope="props">
            <td>{{ props.item.couponId }}</td>
            <td class="text-center px-0">
              <v-btn class="mx-0" icon @click="removeCode(props.item)">
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </td>
          </template> -->
      <!-- <template slot="footer">
            <tr>
              <td>
                <strong>{{ $t('Použito') }}</strong>
              </td>
              <td class="text-right">
                <strong>{{ totalDiscount | currency }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                <strong>{{ $t('Celkem') }}</strong>
              </td>
              <td class="text-right">
                <strong>{{ totalPrice - totalDiscount | currency }}</strong>
              </td>
            </tr>
          </template> -->
    </v-data-table>
  </v-card>
</v-dialog>
</template>

<script>
import BasketMixin from '@/mixins/basket-mixin.js'
import TransfromMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'

export default {
  mixins: [BasketMixin, TransfromMixin],
  components: {},
  data() {
    return {
      headers: [{
        text: this.transform('Kupón'),
        value: 'couponId',
        sortable: false
      }, {
        text: this.transform('Smazat'),
        value: 'options'
      }],
      couponId: null,
      dialog: false,
      reductionRules: [(v) => (v === null || v.length === 0 || v.length <= 12) || this.transform('Text je příliš dlouhý')]
    }
  },
  methods: {
    removeCode(value) {
      this.removeItem(value, true)
    },
    addCode() {
      var c = this.basket.coupons ? [...this.basket.coupons] : []
      c.push({
        couponId: this.couponId
      })
      this.putCoupons(c)
      this.couponId = null
    }
  }
}
</script>
